<template>
  <div class="text-right dropdown-menus">
    <template v-for="menu in menus">
      <v-menu offset-y :open-on-hover="true" :key="menu.title">
        <template v-slot:activator="{ on }">
          <v-btn v-if="menu.children" class="custom-menu-btn" dark v-on="on">{{
            menu.title
          }}</v-btn>
          <v-btn
            v-else
            class="custom-menu-btn"
            dark
            v-on="on"
            @click="goTo(menu.title)"
            >{{ menu.title }}</v-btn
          >
        </template>
        <v-list max-width="150px" v-if="menu.children">
          <v-list-item
            v-for="item in menu.children"
            :key="item.title"
            @click="goTo(item.title)"
          >
           {{ item.title }}
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </div>
</template>

<script>
import { menus } from "../../utils/constants";

export default {
  data: () => ({
    menus: menus,
  }),
  methods: {
    goTo(name) {
      this.$router.push({ name }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.dropdown-menus {
  display: block !important;
}
.custom-menu-btn {
  margin: 0 5px;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  background-color: #990000 !important;
}

/**
 * following are responsive support
 */
@media (max-width: 768px) {
  .dropdown-menus {
    display: none !important;
  }
}
</style>